export default "__VITE_ASSET__BaAK0xC4__"